<template>
	<div class="graph">
		<ScaleTabs
			v-bind:scale="scale"
			:scales="complianceScales"
			@change="setScale"></ScaleTabs>
		<DatePicker
			v-bind:date="date"
			v-bind:startDate="startDate"
			@previous="previous"
			@next="next"></DatePicker>
		<StatusGraph1D
			v-bind:data="complianceData"
			v-bind:startDate="startDate"
			v-bind:date="date"
			v-bind:interval="interval"
			v-bind:binWidth="binWidth">
		</StatusGraph1D>
	</div>
</template>

<script>
import Graph from './index'
import complianceScales from '../config/compliance-scales'

export default {
	name: 'compliance-graph',
	extends: Graph,

	data() {
		return {
			scale: complianceScales[1],
			scales: complianceScales,
			complianceScales
		}
	},

	computed: {
		/**
		 * @function 	complianceData
		 * @desc		Returns the compliance data with its time and status (always/sometimes/never)
		 */
		complianceData() {
			return this.data.map((compliance) => {
				return {
					time: parseInt(compliance.id),
					status: ((compliance.record) ? compliance.record.status : compliance.status) || 'never'
				}
			})
		}
	}
}
</script>
